module.exports = __webpack_public_path__ + "img/bohodiamond.9283cc43.svg";